import React  from "react";
import HyvidPoints from "./components/HyvidPoints";

const HyvidRewards = () => {
  return (
    <div className="space-y-6">
        <HyvidPoints />
    </div>
  );
};

export default HyvidRewards;